module.exports = __webpack_public_path__ + "assets/img/31-m.ae0a39f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/31-m.jpg
// module id = asa4
// module chunks = 0